<template>
  <b-form-group
    label="2. Ukuran"
    label-for="ukuran"
    label-size="lg"
    label-class="pb-0 pt-0"
  >
    <b-row>
      <b-col cols="11">
        <b-form-input
          id="ukuran"
          v-model="ukuranVal"
          disabled
        />
      </b-col>
      <b-col cols="1">
        <label for="satuan">{{ satuanVal }}</label>
      </b-col>
      <b-col
        cols="11"
        offset-md="1"
        class="mt-1"
      >
        <b-form-radio
          v-for="(dataKesesuaianUkuran, i) of dataKesesuaianUkurans"
          :key="i"
          v-model="kesesuaianUkuran"
          :value="dataKesesuaianUkuran.value"
          :state="stateKesesuaianUkuran"
          :disabled="isDisableUkuran"
          @change="handleUkuran"
        >
          {{ dataKesesuaianUkuran.label }}
        </b-form-radio>
        <small
          v-for="(error, index) of errorsKesesuaianUkuran"
          :key="index"
          class="text-danger"
        >
          <span>{{ error.$message }}</span>
        </small>

        <b-col
          v-if="kesesuaianUkuran === '0'"
          cols="11"
          offset-md="1"
          class="mt-1"
        >
          <label
            for="ukuranSeharusnya"
            class="d-block"
          >
            Ukuran Seharusnya
            <small class="text-warning">
              Wajib mengacu pada dokumen yang dapat dipertanggungjawabkan
            </small>
          </label>
          <b-row>
            <b-col cols="11">
              <cleave
                v-model="ukuranSeharusnya"
                class="form-control"
                :options="{
                  ...ruleAngka,
                  numeralDecimalScale: 20,
                }"
                :disabled="
                  satuanSeharusnya == 'UN' ||
                    satuanSeharusnya == 'BH' ||
                    satuanSeharusnya == 'EK' ||
                    satuanSeharusnya == 'UN/BH'
                "
              />
              <small
                v-for="(error, index) of errorsUkuranSeharusnya"
                :key="index"
                class="text-danger"
              >
                <span>{{ error.$message }}</span>
              </small>
            </b-col>
            <b-col cols="1">
              <label for="satuan">{{ satuanSeharusnya }}</label>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
import { ref, watchEffect, watch } from '@vue/composition-api'
import Cleave from 'vue-cleave-component'
import { propsString, propsBoolean, propsArray } from '@/utils/propsTipeData'

export default {
  setup(props, context) {
    const kesesuaianUkuran = ref('')
    const ukuranSeharusnya = ref('')

    watch(kesesuaianUkuran, () => {
      context.emit('emitKesesuaianUkuran', kesesuaianUkuran.value)
    })

    watch(ukuranSeharusnya, () => {
      context.emit('emitUkuranSeharusnya', ukuranSeharusnya.value)
    })

    watchEffect(() => {
      kesesuaianUkuran.value = props.kesesuaianUkuranVal
      ukuranSeharusnya.value = props.ukuranSeharusnyaVal
    })

    const handleUkuran = () => {
      context.emit('emitHandleUkuran')
    }

    return { kesesuaianUkuran, ukuranSeharusnya, handleUkuran }
  },
  components: {
    Cleave,
  },
  props: {
    satuanVal: propsString,
    ukuranVal: propsString,
    kesesuaianUkuranVal: propsString,
    stateKesesuaianUkuran: propsBoolean,
    isDisableUkuran: propsBoolean,
    errorsKesesuaianUkuran: propsArray,
    ukuranSeharusnyaVal: propsString,
    stateUkuranSeharusnya: propsBoolean,
    errorsUkuranSeharusnya: propsArray,
    satuanSeharusnya: propsString,
  },
  data() {
    return {
      dataKesesuaianUkurans: [
        { label: 'Sesuai Dengan Data Lama', value: '1' },
        { label: 'Tidak Sesuai Dengan Data Lama', value: '0' },
      ],
      ruleAngka: {
        numeral: true,
        numeralDecimalMark: ',',
        delimiter: '.',
      },
    }
  },
}
</script>
